import React from 'react'
import Navbar from './Navbar'
import './gallery.css';
import Footer from './Footer'
export default function Gallery() {
  return (
    <>
    <div className="main-wrapper page">
  <Navbar />
{/* 
  <div className="content-wrapper">
    <div className="galery-wrapper">
      <div className="container">
        <div className="galery-title text-center">
          <h4 className="heading-regular">ALUMNI GALLERY</h4>
        </div>
        <div className="galery-content">
          <ul>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery1.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-1.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery2.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-2.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery3.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-3.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery4.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-4.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery5.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-5.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery6.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-6.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery7.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-7.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery8.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-8.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery9.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-9.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery10.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-10.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery11.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-11.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery12.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-12.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery13.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-13.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery14.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-14.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery15.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-15.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className="col-sm-3 col-xs-6">
              <div className="galery-item">
                <img src="images/galery16.jpg" alt="" />
                <div className="galery-content">
                  <h4>Best Friend Ever</h4>
                  <a href="#" className="popup-click">
                    <span className="lnr lnr-magnifier" />
                  </a>
                </div>
                <div className="box-content-item" style={{ display: "none" }}>
                  <div className="box-img">
                    <img src="images/galery-popup-16.jpg" alt="" />
                  </div>
                  <div className="desc">
                    <p>
                      Duis autem vel eum iriure dolor in hendrerit in vulputate
                      velit esse molestie consequat vel illum dolore eu feugiat
                      nulla facilisis at vero eros et accumsan et iusto odio.
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="pagination-wrapper text-center">
          <ul className="pagination">
            <li className="prev">
              <a href="#">Previous</a>
            </li>
            <li>
              <a href="#">1</a>
            </li>
            <li>
              <a href="#">2</a>
            </li>
            <li className="current">
              <span>3</span>
            </li>
            <li>
              <a href="#">4</a>
            </li>
            <li>
              <a href="#">5</a>
            </li>
            <li className="next">
              <a href="#">Next</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="newsletter newsletter-parallax">
      <div className="container">
        <div className="newsletter-wrapper text-center">
          <div className="newsletter-title">
            <h2 className="heading-light">Keep Up and Join Our Newsletter</h2>
            <p className="text-white">
              Duis autem vel eum iriure dolor in hendrerit in vulputate.
            </p>
          </div>
          <form name="subscribe-form" target="_blank" className="form-inline">
            <input
              type="text"
              className="form-control text-center form-text-light"
              name="EMAIL"
              defaultValue=""
              placeholder="E-mail Address"
            />
            <button type="submit" className="button bnt-theme">
              subscribe
            </button>
          </form>
        </div>
      </div>
    </div>

  </div> */}

  <section>

  <div className="gal-container">
  <div className="about-us" style={{paddingTop:"20px"}}>
  <div className="about-us-title text-center" data-aos="fade-up">
        <div className="container">
          <h1 className="heading-bold text-uppercase">Gallery</h1>
        </div>
      </div>
      </div>
  <div className="section-title" >
          <h2>Our Memories</h2>
        </div>
        <div className='gallery-section' >
    <div className="col-md-8 col-sm-12 co-xs-12 gal-item">
  
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#1">
          <img src="images/1.jpeg" />
        </a>
        <div className="modal fade" id={1} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/1.jpeg" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#2">
          <img src="images/2.avif" />
        </a>
        <div className="modal fade" id={2} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/2.avif" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#3">
          <img src="images/3.jfif" />
        </a>
        <div className="modal fade" id={3} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/3.jfif" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#4">
          <img src="images/4.webp" />
        </a>
        <div className="modal fade" id={4} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/4.webp" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#5">
          <img src="images/5.jpg" />
        </a>
        <div className="modal fade" id={5} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/5.jpg" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#6">
          <img src="images/6.jfif" />
        </a>
        <div className="modal fade" id={6} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/6.jfif" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#7">
          <img src="images/7.jpg" />
        </a>
        <div className="modal fade" id={7} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/7.jpg" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#8">
          <img src="images/8.jpg" />
        </a>
        <div className="modal fade" id={8} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/8.jpg" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#9">
          <img src="images/8.avif" />
        </a>
        <div className="modal fade" id={9} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/8.avif" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-8 col-sm-12 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#10">
          <img src="images/9.jfif" />
        </a>
        <div className="modal fade" id={10} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="images/9.jfif" />
              </div>
              <div className="col-md-12 description">
                <h4>LIT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#11">
          <img src="http://nabeel.co.in/files/bootsnipp/gallery/11.jpg" />
        </a>
        <div className="modal fade" id={11} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="http://nabeel.co.in/files/bootsnipp/gallery/11.jpg" />
              </div>
              <div className="col-md-12 description">
                <h4>This is the leventh one on my Gallery</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#12">
          <img src="http://nabeel.co.in/files/bootsnipp/gallery/12.jpg" />
        </a>
        <div className="modal fade" id={12} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="http://nabeel.co.in/files/bootsnipp/gallery/12.jpg" />
              </div>
              <div className="col-md-12 description">
                <h4>This is the 12th one on my Gallery</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#13">
          <img src="http://nabeel.co.in/files/bootsnipp/gallery/13.jpg" />
        </a>
        <div className="modal fade" id={13} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="http://nabeel.co.in/files/bootsnipp/gallery/13.jpg" />
              </div>
              <div className="col-md-12 description">
                <h4>This is the 13th one on my Gallery</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#14">
          <img src="http://nabeel.co.in/files/bootsnipp/gallery/14.jpg" />
        </a>
        <div className="modal fade" id={14} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="http://nabeel.co.in/files/bootsnipp/gallery/14.jpg" />
              </div>
              <div className="col-md-12 description">
                <h4>This is the 14th one on my Gallery</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#15">
          <img src="http://nabeel.co.in/files/bootsnipp/gallery/15.jpg" />
        </a>
        <div className="modal fade" id={15} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="http://nabeel.co.in/files/bootsnipp/gallery/15.jpg" />
              </div>
              <div className="col-md-12 description">
                <h4>This is the 15th one on my Gallery</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-4 col-sm-6 co-xs-12 gal-item">
      <div className="box">
        <a href="#" data-toggle="modal" data-target="#16">
          <img src="http://nabeel.co.in/files/bootsnipp/gallery/16.jpg" />
        </a>
        <div className="modal fade" id={16} tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <div className="modal-body">
                <img src="http://nabeel.co.in/files/bootsnipp/gallery/16.jpg" />
              </div>
              <div className="col-md-12 description">
                <h4>This is the 16th one on my Gallery</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    </div>
  </div>
</section>

<Footer/>
  {/* <div className="bg-popup" />
  <div className="wrapper-popup">
    <a href="javascript:void(0)" className="close-popup">
      <span className="lnr lnr-cross-circle" />
    </a>
    <div className="popup-content"></div>
  </div> */}
</div>

    </>
  )
}
